const storageAreas = ['Shelf', 'Solvent Shed', 'Shop'];

function normalizeStorageArea(value) {
  return storageAreas.find((area) => area.toLowerCase() === String(value || '').trim().toLowerCase()) || null;
}

export function currentPartPlacement(part) {
  if (part?.unit_intended_for) return { truckId: Number(part.unit_intended_for), storageArea: null };
  const destination = normalizeStorageArea(part?.unit_intended_for_location);
  if (destination) return { truckId: null, storageArea: destination };
  if (part?.unit_came_off_from) return { truckId: Number(part.unit_came_off_from), storageArea: null };
  const source = normalizeStorageArea(part?.unit_came_off_from_location);
  if (source) return { truckId: null, storageArea: source };
  const location = String(part?.location || '').trim();
  const legacyArea = storageAreas.find((area) => (
    new RegExp(`^${area}(?:$|\\s*[-:|])`, 'i').test(location)
  ));
  return { truckId: null, storageArea: legacyArea || 'Shelf' };
}

export function isPurchaseShelfPart(part) {
  return currentPartPlacement(part).storageArea === 'Shelf'
    && String(part?.location || '').trim().toUpperCase().startsWith('B');
}

export function partBayLocation(part) {
  const location = String(part?.location || '').trim();
  const { storageArea } = currentPartPlacement(part);
  if (!storageArea) return location;
  if (location.toLowerCase() === storageArea.toLowerCase()) return '';
  return location.replace(new RegExp(`^${storageArea}\\s*[-:|]\\s*`, 'i'), '');
}
